export default __webpack_public_path__ + "static/media/Van focus naar EDO-project.390313d1.zip";